// Set up branch config - so we can default the agent email address
export const CONNELLS_BRANCH_CONFIG = [
  {
    id: "allen-harris-abingdon",
    email: "Abingdon@allenandharris.co.uk",
    referrer: "Allen & Harris - Abingdon",
    logo: "allen-and-harris",
    alt: "Allen & Harris logo",
  },
  {
    id: "allen-harris-didcot",
    email: "Didcot@allenandharris.co.uk",
    referrer: "Allen & Harris - Didcot",
    logo: "allen-and-harris",
    alt: "Allen & Harris logo",
  },
  {
    id: "allen-harris-oxford",
    email: "Oxford@allenandharris.co.uk",
    referrer: "Allen & Harris - Oxford",
    logo: "allen-and-harris",
    alt: "Allen & Harris logo",
  },
  {
    id: "allen-harris-wallingford",
    email: "Wallingford@allenandharris.co.uk",
    referrer: "Allen & Harris - Wallingford",
    logo: "allen-and-harris",
    alt: "Allen & Harris logo",
  },
  {
    id: "allen-harris-witney",
    email: "Witney@allenandharris.co.uk",
    referrer: "Allen & Harris - Witney",
    logo: "allen-and-harris",
    alt: "Allen & Harris logo",
  },

  {
    id: "sequence-aylesbury",
    email: "Aylesbury@brownandmerry.co.uk",
    referrer: "Brown & Merry - Aylesbury",
    logo: "brown-and-merry",
    alt: "Brown and Merry logo",
  },
  {
    id: "sequence-berkhamsted",
    email: "Berkhamsted@brownandmerry.co.uk",
    referrer: "Brown & Merry - Berkhamsted",
    logo: "brown-and-merry",
    alt: "Brown and Merry logo",
  },
  {
    id: "sequence-chesham",
    email: "Chesham@brownandmerry.co.uk",
    referrer: "Brown & Merry - Chesham",
    logo: "brown-and-merry",
    alt: "Brown and Merry logo",
  },
  {
    id: "sequence-hemel-hempstead",
    email: "HemelHempstead@brownandmerry.co.uk",
    referrer: "Brown & Merry - Hemel Hempstead",
    logo: "brown-and-merry",
    alt: "Brown and Merry logo",
  },
  {
    id: "sequence-tring",
    email: "Tring@brownandmerry.co.uk",
    referrer: "Brown & Merry - Tring",
    logo: "brown-and-merry",
    alt: "Brown and Merry logo",
  },
  {
    id: "sequence-watford",
    email: "Watford@brownandmerry.co.uk",
    referrer: "Brown & Merry - Watford",
    logo: "brown-and-merry",
    alt: "Brown and Merry logo",
  },
  {
    id: "sequence-wendover",
    email: "Wendover@brownandmerry.co.uk",
    referrer: "Brown & Merry - Wendover",
    logo: "brown-and-merry",
    alt: "Brown and Merry logo",
  },
  {
    id: "sequence-burnham",
    email: "Burnham@rogerplatt.co.uk",
    referrer: "Roger Platt - Burnham",
    logo: "roger-platt",
    alt: "Roger Platt logo",
  },
  {
    id: "sequence-lower-earley",
    email: "LowerEarley@rogerplatt.co.uk",
    referrer: "Roger Platt - Lower Earley",
    logo: "roger-platt",
    alt: "Roger Platt logo",
  },
  {
    id: "sequence-maidenhead",
    email: "Maidenhead@rogerplatt.co.uk",
    referrer: "Roger Platt - Maidenhead",
    logo: "roger-platt",
    alt: "Roger Platt logo",
  },
  {
    id: "sequence-enfield",
    email: "info@barnfields.com",
    referrer: "Barnfields - Enfield",
    logo: "barnfields",
    alt: "Barnfields logo",
  },
  {
    id: "sequence-barking",
    email: "barking@williamhbrown.co.uk",
    referrer: "William H Brown - Barking",
    logo: "william-h-brown",
    alt: "William H Brown logo",
  },
  {
    id: "sequence-braintree",
    email: "braintree@williamhbrown.co.uk",
    referrer: "William H Brown - Braintree",
    logo: "william-h-brown",
    alt: "William H Brown logo",
  },
  {
    id: "sequence-brentwood",
    email: "brentwood@williamhbrown.co.uk",
    referrer: "William H Brown - Brentwood",
    logo: "william-h-brown",
    alt: "William H Brown logo",
  },
  {
    id: "sequence-broxbourne",
    email: "Broxbourne@williamhbrown.co.uk",
    referrer: "William H Brown - Broxbourne",
    logo: "william-h-brown",
    alt: "William H Brown logo",
  },
  {
    id: "sequence-chelmsford",
    email: "Chelmsford@williamhbrown.co.uk",
    referrer: "William H Brown - Chelmsford",
    logo: "william-h-brown",
    alt: "William H Brown logo",
  },
  {
    id: "sequence-chelmsford-south",
    email: "ChelmsfordSouth@williamhbrown.co.uk",
    referrer: "William H Brown - Chelmsford South",
    logo: "william-h-brown",
    alt: "William H Brown logo",
  },
  {
    id: "sequence-clactononsea",
    email: "Clactononsea@williamhbrown.co.uk",
    referrer: "William H Brown - Clacton on Sea",
    logo: "william-h-brown",
    alt: "William H Brown logo",
  },
  {
    id: "sequence-coggeshall",
    email: "Coggeshall@williamhbrown.co.uk",
    referrer: "William H Brown - Coggeshall",
    logo: "william-h-brown",
    alt: "William H Brown logo",
  },
  {
    id: "sequence-colchester-culver-street-west",
    email: "colchester@williamhbrown.co.uk",
    referrer: "William H Brown - Colchester Culver Street West",
    logo: "william-h-brown",
    alt: "William H Brown logo",
  },
  {
    id: "sequence-colchester-st-johns",
    email: "colchesterstjohns@williamhbrown.co.uk",
    referrer: "William H Brown - Colchester St Johns",
    logo: "william-h-brown",
    alt: "William H Brown logo",
  },
  {
    id: "sequence-gidea-park",
    email: "gideapark@williamhbrown.co.uk",
    referrer: "William H Brown - Gidea Park",
    logo: "william-h-brown",
    alt: "William H Brown logo",
  },
  {
    id: "sequence-grays",
    email: "grays@williamhbrown.co.uk",
    referrer: "William H Brown - Grays",
    logo: "william-h-brown",
    alt: "William H Brown logo",
  },
  {
    id: "sequence-halstead",
    email: "halstead@williamhbrown.co.uk",
    referrer: "William H Brown - Halstead",
    logo: "william-h-brown",
    alt: "William H Brown logo",
  },
  {
    id: "sequence-harlow",
    email: "harlow@williamhbrown.co.uk",
    referrer: "William H Brown - Harlow",
    logo: "william-h-brown",
    alt: "William H Brown logo",
  },
  {
    id: "sequence-harwich",
    email: "Harwich@williamhbrown.co.uk",
    referrer: "William H Brown - Harwich",
    logo: "william-h-brown",
    alt: "William H Brown logo",
  },
  {
    id: "sequence-hertford",
    email: "Hertford@williamhbrown.co.uk",
    referrer: "William H Brown - Hertford",
    logo: "william-h-brown",
    alt: "William H Brown logo",
  },
  {
    id: "sequence-hoddesdon",
    email: "Hoddesdon@williamhbrown.co.uk",
    referrer: "William H Brown - Hoddesdon",
    logo: "william-h-brown",
    alt: "William H Brown logo",
  },
  {
    id: "sequence-ipswich",
    email: "Ipswich@williamhbrown.co.uk",
    referrer: "William H Brown - Ipswich",
    logo: "william-h-brown",
    alt: "William H Brown logo",
  },
  {
    id: "sequence-ipswich-east",
    email: "IpswichEast@williamhbrown.co.uk",
    referrer: "William H Brown - Ipswich East",
    logo: "william-h-brown",
    alt: "William H Brown logo",
  },
  {
    id: "sequence-maldon",
    email: "Maldon@williamhbrown.co.uk",
    referrer: "William H Brown - Maldon",
    logo: "william-h-brown",
    alt: "William H Brown logo",
  },
  {
    id: "sequence-st-albans",
    email: "StAlbans@williamhbrown.co.uk",
    referrer: "William H Brown - St Albans",
    logo: "william-h-brown",
    alt: "William H Brown logo",
  },
  {
    id: "sequence-stevenage",
    email: "stevenage@williamhbrown.co.uk",
    referrer: "William H Brown - Stevenage",
    logo: "william-h-brown",
    alt: "William H Brown logo",
  },
  {
    id: "sequence-sudbury",
    email: "sudbury@williamhbrown.co.uk",
    referrer: "William H Brown - Sudbury",
    logo: "william-h-brown",
    alt: "William H Brown logo",
  },
  {
    id: "sequence-ware",
    email: "Ware@williamhbrown.co.uk",
    referrer: "William H Brown - Ware",
    logo: "william-h-brown",
    alt: "William H Brown logo",
  },
  {
    id: "sequence-welwyn-garden-city",
    email: "WelwynGardenCity@williamhbrown.co.uk",
    referrer: "William H Brown - Welwyn Garden City",
    logo: "william-h-brown",
    alt: "William H Brown logo",
  },
  {
    id: "sequence-woodbridge",
    email: "Woodbridge@williamhbrown.co.uk",
    referrer: "William H Brown - Woodbridge",
    logo: "william-h-brown",
    alt: "William H Brown logo",
  },
  {
    id: "sequence-bedford",
    email: "Bedford@williamhbrown.co.uk",
    referrer: "William H Brown - Bedford",
    logo: "william-h-brown",
    alt: "William H Brown logo",
  },
  {
    id: "sequence-corby",
    email: "Corby@williamhbrown.co.uk",
    referrer: "William H Brown - Corby",
    logo: "william-h-brown",
    alt: "William H Brown logo",
  },
  {
    id: "sequence-kettering",
    email: "Kettering@williamhbrown.co.uk",
    referrer: "William H Brown - Kettering",
    logo: "william-h-brown",
    alt: "William H Brown logo",
  },
  {
    id: "sequence-northampton",
    email: "Northampton@williamhbrown.co.uk",
    referrer: "William H Brown - Northampton",
    logo: "william-h-brown",
    alt: "William H Brown logo",
  },
  {
    id: "sequence-northampton-north",
    email: "NorthamptonNorth@williamhbrown.co.uk",
    referrer: "William H Brown - Northampton North",
    logo: "william-h-brown",
    alt: "William H Brown logo",
  },
  {
    id: "sequence-raunds",
    email: "Raunds@williamhbrown.co.uk",
    referrer: "William H Brown - Raunds",
    logo: "william-h-brown",
    alt: "William H Brown logo",
  },
  {
    id: "sequence-rainham",
    email: "rainham@williamhbrown.co.uk",
    referrer: "William H Brown - Rainham",
    logo: "william-h-brown",
    alt: "William H Brown logo",
  },
  {
    id: "sequence-rothwell",
    email: "Rothwell@williamhbrown.co.uk",
    referrer: "William H Brown - Rothwell",
    logo: "william-h-brown",
    alt: "William H Brown logo",
  },
  {
    id: "sequence-rushden",
    email: "Rushden@williamhbrown.co.uk",
    referrer: "William H Brown - Rushden",
    logo: "william-h-brown",
    alt: "William H Brown logo",
  },
  {
    id: "sequence-wellingborough",
    email: "Wellingborough@williamhbrown.co.uk",
    referrer: "William H Brown - Wellingborough",
    logo: "william-h-brown",
    alt: "William H Brown logo",
  },
  {
    id: "sequence-peterborough",
    email: "peterborough@williamhbrown.co.uk",
    referrer: "William H Brown - Peterborough",
    logo: "william-h-brown",
    alt: "William H Brown logo",
  },
  {
    id: "sequence-yaxley",
    email: "yaxley@williamhbrown.co.uk",
    referrer: "William H Brown - Yaxley",
    logo: "william-h-brown",
    alt: "William H Brown logo",
  },
  {
    id: "sequence-fletton",
    email: "fletton@williamhbrown.co.uk",
    referrer: "William H Brown - Fletton",
    logo: "william-h-brown",
    alt: "William H Brown logo",
  },
  {
    id: "hurfords-castor",
    email: "info@hurfords.co.uk",
    referrer: "Hurfords - Castor",
    logo: "hurfords",
    alt: "Hurfords logo",
  },
  {
    id: "hurfords-stamford",
    email: "stamford@hurfords.co.uk",
    referrer: "Hurfords - Stamford",
    logo: "hurfords",
    alt: "Hurfords logo",
  },
  {
    id: "hurfords-uppingham",
    email: "uppingham@hurfords.co.uk",
    referrer: "Hurfords - Uppingham",
    logo: "hurfords",
    alt: "Hurfords logo",
  },
  {
    id: "kevin-henry-saffron-walden",
    email: "sales@kevinhenry.co.uk",
    referrer: "Kevin Henry - Saffron Walden",
    logo: "kevin-henry",
    alt: "Kevin Henry logo",
  },
  {
    id: "quentin-marks-bourne",
    email: "sales@quentinmarks.co.uk",
    referrer: "Quentin Marks - Bourne",
    logo: "sharman-quinney",
    alt: "Sharman Quinney logo",
  },
  {
    id: "pattison-lane-desborough",
    email: "desborough@pattisonlane.co.uk",
    referrer: "Pattison Lane - Desborough",
    logo: "pattison-lane",
    alt: "Pattison Lane logo",
  },
  {
    id: "pattison-lane-kettering",
    email: "kettering@pattisonlane.co.uk",
    referrer: "Pattison Lane Estate Agents - Kettering",
    logo: "pattison-lane",
    alt: "Pattison Lane logo",
  },
  {
    id: "sharman-quinney-chatteris",
    email: "chatteris@sharmanquinney.co.uk",
    referrer: "Sharman Quinney - Chatteris",
    logo: "sharman-quinney",
    alt: "Sharman Quinney logo",
  },
  {
    id: "sharman-quinney-march",
    email: "march@sharmanquinney.co.uk",
    referrer: "Sharman Quinney - March",
    logo: "sharman-quinney",
    alt: "Sharman Quinney logo",
  },
  {
    id: "sharman-quinney-cambourne",
    email: "cambourne@sharmanquinney.co.uk",
    referrer: "Sharman Quinney - Cambourne",
    logo: "sharman-quinney",
    alt: "Sharman Quinney logo",
  },
  {
    id: "sharman-quinney-godmanchester",
    email: "godmanchester@sharmanquinney.co.uk",
    referrer: "Sharman Quinney - Godmanchester",
    logo: "sharman-quinney",
    alt: "Sharman Quinney logo",
  },
  {
    id: "sharman-quinney-hampton",
    email: "hampton@sharmanquinney.co.uk",
    referrer: "Sharman Quinney - Hampton",
    logo: "sharman-quinney",
    alt: "Sharman Quinney logo",
  },
  {
    id: "sharman-quinney-market-deeping",
    email: "marketdeeping@sharmanquinney.co.uk",
    referrer: "Sharman Quinney - Market Deeping",
    logo: "sharman-quinney",
    alt: "Sharman Quinney logo",
  },
  {
    id: "sharman-quinney-peterborough",
    email: "peterborough@sharmanquinney.co.uk",
    referrer: "Sharman Quinney - Peterborough",
    logo: "sharman-quinney",
    alt: "Sharman Quinney logo",
  },
  {
    id: "sharman-quinney-stanground",
    email: "stanground@sharmanquinney.co.uk",
    referrer: "Sharman Quinney - Stanground",
    logo: "sharman-quinney",
    alt: "Sharman Quinney logo",
  },
  {
    id: "sharman-quinney-werrington",
    email: "werrington@sharmanquinney.co.uk",
    referrer: "Sharman Quinney - Werrington",
    logo: "sharman-quinney",
    alt: "Sharman Quinney logo",
  },
  {
    id: "sharman-quinney-whittlesey",
    email: "whittlesey@sharmanquinney.co.uk",
    referrer: "Sharman Quinney - Whittlesey",
    logo: "sharman-quinney",
    alt: "Sharman Quinney logo",
  },
  {
    id: "sharman-quinney-great-shelford",
    email: "greatshelford@sharmanquinney.co.uk",
    referrer: "Sharman Quinney - Great Shelford",
    logo: "sharman-quinney",
    alt: "Sharman Quinney logo",
  },
  {
    id: "sharman-quinney-orchard-park-cambridge",
    email: "orchardpark@sharmanquinney.co.uk",
    referrer: "Sharman Quinney - Orchard Park",
    logo: "sharman-quinney",
    alt: "Sharman Quinney logo",
  },
  {
    id: "sharman-quinney-oundle",
    email: "oundle@sharmanquinney.co.uk",
    referrer: "Sharman Quinney - Oundle",
    logo: "sharman-quinney",
    alt: "Sharman Quinney logo",
  },
  {
    id: "sharman-quinney-ramsey",
    email: "ramsey@sharmanquinney.co.uk",
    referrer: "Sharman Quinney - Ramsey",
    logo: "sharman-quinney",
    alt: "Sharman Quinney logo",
  },
  {
    id: "sharman-quinney-thrapston",
    email: "thrapston@sharmanquinney.co.uk",
    referrer: "Sharman Quinney - Thrapston",
    logo: "sharman-quinney",
    alt: "Sharman Quinney logo",
  },
  {
    id: "sharman-quinney-yaxley",
    email: "yaxley@sharmanquinney.co.uk",
    referrer: "Sharman Quinney - Yaxley",
    logo: "sharman-quinney",
    alt: "Sharman Quinney logo",
  },
  {
    id: "connells-harpenden",
    email: "Harpenden@connells.co.uk",
    referrer: "Connells - Harpenden",
    logo: "connells",
    alt: "Connells logo",
  },
  {
    id: "connells-hitchin",
    email: "Hitchin@connells.co.uk",
    referrer: "Connells - Hitchin",
    logo: "connells",
    alt: "Connells logo",
  },
  {
    id: "connells-letchworth",
    email: "Letchworth@connells.co.uk",
    referrer: "Connells - Letchworth",
    logo: "connells",
    alt: "Connells logo",
  },
  {
    id: "connells-marshalswick",
    email: "Marshalswick@connells.co.uk",
    referrer: "Connells - Marshalswick",
    logo: "connells",
    alt: "Connells logo",
  },
  {
    id: "connells-st-albans",
    email: "StAlbans@connells.co.uk",
    referrer: "Connells - St Albans",
    logo: "connells",
    alt: "Connells logo",
  },
  {
    id: "connells-stevenage",
    email: "Stevenage@connells.co.uk",
    referrer: "Connells - Stevenage",
    logo: "connells",
    alt: "Connells logo",
  },
  {
    id: "connells-welwyn-garden-city",
    email: "WelwynGardenCity@connells.co.uk",
    referrer: "Connells - Welwyn Garden City",
    logo: "connells",
    alt: "Connells logo",
  },
  {
    id: "connells-ipswich",
    email: "Ipswich@connells.co.uk",
    referrer: "Connells - Ipswich",
    logo: "connells",
    alt: "Connells logo",
  },
  {
    id: "sequence-framlingham",
    email: "Framlingham@williamhbrown.co.uk",
    referrer: "William H Brown - Framlingham",
    logo: "william-h-brown",
    alt: "William H Brown logo",
  },
  {
    id: "sequence-stowmarket",
    email: "Stowmarket@williamhbrown.co.uk",
    referrer: "William H Brown - Stowmarket",
    logo: "william-h-brown",
    alt: "William H Brown logo",
  },
];

// Use the list of branches, to see if we should show the Connells Intro
export const CONNELLS_BRANCHES = CONNELLS_BRANCH_CONFIG.map((branch) => branch.id);

export const getReferringBranchConfig = (branchId) => {
  return CONNELLS_BRANCH_CONFIG.filter((branch) => branch.id === branchId)[0];
};

// Define the referral sources for Connells
export const CONNELLS_REFERRAL_SOURCES = [
  "home_conveyancing_seller",
  "home_conveyancing_buyer",
  "home_conveyancing_buyer_searches_prepaid",
];

// Helper to hide content for all Connells referrals
// - including our internal referral process
export const isConnellsReferral = (source) => {
  return CONNELLS_REFERRAL_SOURCES.includes(source);
};

// Helper to hide content for Connells branches ONLY
// - but not change our internal referral process
export const isConnellsBranch = (id) => {
  return CONNELLS_BRANCHES.includes(id);
};

// Helper to extract the branch ID from an internal version of the referral
// code link (with an internal- prefix). Returns the value without the prefix
// iff it matches one of the branch IDs.
export const parseInternalConnellsBranchCode = (id) => {
  const prefix = "internal-";
  if (!id || !id.startsWith(prefix)) {
    return null;
  }
  const branchId = id.slice(prefix.length);
  if (CONNELLS_BRANCHES.includes(branchId)) {
    return branchId;
  }
  return null;
};
